import i18n from '@/i18n'

const extensionIdProp = 'number'

// Base config without labels - labels are added dynamically via getExtensionsSortOptions()
interface BaseSortOption {
    value: string
    prop: string
    order: 'asc' | 'desc'
    labelKey: string
    orderKey: string
}

interface SortOptionWithLabel extends Omit<BaseSortOption, 'labelKey' | 'orderKey'> {
    label: string
}

const extensionsSortOptionsBase: BaseSortOption[] = [
    {
        value: 'number-asc',
        prop: extensionIdProp,
        order: 'asc',
        labelKey: 'extensions.sort.created.asc',
        orderKey: 'sorting.asc'
    },
    {
        value: 'number-desc',
        prop: extensionIdProp,
        order: 'desc',
        labelKey: 'extensions.sort.created.desc',
        orderKey: 'sorting.desc'
    },
    {
        value: 'userName-asc',
        prop: 'userName',
        order: 'asc',
        labelKey: 'extensions.sort.userName.asc',
        orderKey: 'sorting.asc'
    },
    {
        value: 'userName-desc',
        prop: 'userName',
        order: 'desc',
        labelKey: 'extensions.sort.userName.desc',
        orderKey: 'sorting.desc'
    },
    {
        value: 'statusTime-asc',
        prop: 'statusTime',
        order: 'asc',
        labelKey: 'extensions.sort.statusTime.asc',
        orderKey: 'sorting.asc'
    },
    {
        value: 'statusTime-desc',
        prop: 'statusTime',
        order: 'desc',
        labelKey: 'extensions.sort.statusTime.desc',
        orderKey: 'sorting.desc'
    },
    {
        value: 'callDuration-asc',
        prop: 'callDuration',
        order: 'asc',
        labelKey: 'extensions.sort.callDuration.asc',
        orderKey: 'sorting.asc'
    },
    {
        value: 'callDuration-desc',
        prop: 'callDuration',
        order: 'desc',
        labelKey: 'extensions.sort.callDuration.desc',
        orderKey: 'sorting.desc'
    },
]

// Helper function to generate label at runtime when translations are available
function generateSortOptionLabel (option: BaseSortOption): SortOptionWithLabel {
    return {
        label: `${i18n.global.t(option.labelKey)} - ${i18n.global.t(option.orderKey)}`,
        value: option.value,
        prop: option.prop,
        order: option.order
    }
}

// Returns sort options with translated labels - call at runtime when translations are available
export function getExtensionsSortOptions (): SortOptionWithLabel[] {
    return extensionsSortOptionsBase.map(generateSortOptionLabel)
}

// Returns sort options without call duration options - call at runtime when translations are available
export function getExtensionsSortOptionsWithoutCalls (): SortOptionWithLabel[] {
    return extensionsSortOptionsBase.slice(0, -2).map(generateSortOptionLabel)
}
